
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13222',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13222",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.771",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9951",
  "foundations-components": "static-1-ech-accordiontransition-jank.34",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.34",
  "foundations-theming": "static-1.4771",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8326",
  "hub-http-shared-msw-handlers": "static-1.10608",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11785",
  "I18n": "static-7.1672",
  "jasmine-runner": "static-1.6747",
  "marketplace-discovery-studio-lib": "static-1.624",
  "marketplace-storefront-base": "static-1.13285",
  "quartz": "static-1.7450",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17014",
  "reactive-variable-buffer-atom": "static-1.3150",
  "reporting-testing-lib": "static-1.10730",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12820",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7619",
  "ui-addon-i18n": "static-1.11442",
  "ui-addon-react-router-dom": "static-1.9831",
  "unified-auth": "static-1.912",
  "unified-auth-core-lib": "static-1.1194",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8396",
  "hub-http": "static-1.6507",
  "integrations-lib": "static-1.17016",
  "marketplace-ui-common": "static-1.20716",
  "marketplace-ui-install": "static-1.702",
  "property-management-iframe": "static-1.14123",
  "quartz-config": "static-1.1228",
  "quartz-core": "static-1.6669",
  "quartz-routing": "static-1.880",
  "quick-fetch": "static-1.4127",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4962",
  "ts-schema": "static-1.4289",
  "ui-universal-auth": "static-1.9398",
  "UIComponents": "static-3.8731",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3615",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3727",
  "quartz-webpack": "static-1.3674",
  "bend-plugin-quartz-routing": "static-1.528",
  "ai-components-ui-library": "static-1.9702",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5180",
  "pulse": "static-1.924",
  "react-codemirror": "static-1.10936",
  "ui-extensions-preview-lib": "static-1.596",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.34",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2487",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9719",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.69",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5553",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2624",
  "ui-fonts": "static-1.1047",
  "ui-images": "static-2.1246",
  "bend-plugin-foundations-theming": "static-1.3254",
  "foundations-theming-base": "static-1.3756",
  "stylex": "static-1.41",
  "HeadJS": "static-2.796",
  "hs-test-utils-bend-plugin": "static-1.3437",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4608",
  "ui-addon-video-player": "static-1.8998",
  "ai-rendering-library": "static-1.11092",
  "chirp-fetch": "static-1.2189",
  "connections-embed-lib": "static-1.1503",
  "copilot-toolkit": "static-1.11841",
  "feedback-loader": "static-1.29802",
  "laboratory-lib": "static-3.7447",
  "marketplace-embed": "static-1.22897",
  "marketplace-ui-details": "static-1.10611",
  "marketplace-ui-reviews": "static-1.20671",
  "marketplace-ui-tracking": "static-1.14886",
  "sanitize-text": "static-1.8449",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7197",
  "quartz-head": "static-1.1115",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4950",
  "immer": "static-1.101",
  "immerable": "static-1.4443",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2685",
  "reporting-data": "static-1.68797",
  "cssUtils": "static-1.915",
  "flux-actions": "static-1.367",
  "react-colorpicker": "static-2.10513",
  "react-dnd-compat": "static-1.4912",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10665",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.682",
  "marketplace-ui-apps-core": "static-1.19248",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4803",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.34",
  "quartz-i18n": "static-1.1125",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.445",
  "ads-unified-auth-lib": "static-1.1339",
  "generic-oauth-auth-lib": "static-1.40",
  "google-sheets-integration-lib": "static-1.1015",
  "microsoft-drive-auth-lib": "static-1.129",
  "surveymonkey-integration-lib": "static-1.471",
  "slack-ui-library": "static-1.10694",
  "fsm": "static-1.4044",
  "customer-data-objects": "static-1.7986",
  "property-translator": "static-1.5691",
  "hs-locale-management": "static-1.290",
  "frontend-preferences-client": "static-1.8218",
  "hs-promise-utils": "static-1.5890",
  "hubspot-apollo-client": "static-1.5172",
  "integrations-error-boundary-lib": "static-1.14431",
  "integrations-tracking-lib": "static-1.5902",
  "native-integrations-shared-strings": "static-1.8072",
  "sanitize": "static-1.4767",
  "superstore": "static-1.5052",
  "ui-shepherd-react": "static-3.10565",
  "ai-settings-ui-library": "static-1.8343",
  "hub-http-janus": "static-1.878",
  "hubspotter-http": "static-1.4861",
  "immutable-less": "static-1.4945",
  "marketplace-ui-client-types": "static-1.18123",
  "nav-meta": "static-1.30453",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18377",
  "ui-product-approvals-common": "static-1.1032",
  "ai-studio-lib": "static-1.12440",
  "hubspot-prosemirror": "static-1.18955",
  "integrations-reconnect-lib": "static-1.476",
  "ui-addon-iframeable": "static-1.9371",
  "ui-addon-integrations-directory-panel": "static-2.8321",
  "ui-product-approvals": "static-1.29137",
  "ui-tool-access": "static-1.10450",
  "inbound-db-properties-service-client": "static-1.4052",
  "property-management-common": "static-1.6411",
  "opentelemetry-fe-types": "static-1.65",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.440",
  "quartz-auth": "static-1.1125",
  "quartz-test": "static-1.1125",
  "quartz-tracking": "static-1.829",
  "trellis-components": "static-1.2643",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.372",
  "HubStyle": "static-2.12092",
  "bender-build-tools": "static-1.3441",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22997",
  "ContentUtils": "static-1.69113",
  "customer-data-objects-ui-components": "static-1.13326",
  "sassPrefix": "static-1.187",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.427",
  "batch-promise": "static-1.1838",
  "event-emitter": "static-1.1248",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5749",
  "magpie-types": "static-1.5209",
  "stylex-utils": "static-1.139",
  "trellis-theming": "static-1.1269",
  "avatar-components": "static-1.2775",
  "breeze-engine-core": "static-1.995",
  "breeze-onboarding-components": "static-1.717",
  "customer-data-filters-ui": "static-1.40902",
  "customer-data-reference-ui-components": "static-1.13472",
  "embedded-academy-lib": "static-1.15494",
  "ExportDialog": "static-6.10673",
  "global-styles-ai-lib": "static-1.107",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.600",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42032",
  "reporting-snowflake": "static-1.57414",
  "reporting-ui-components": "static-2.66067",
  "reporting-visualizations": "static-1.60872",
  "trial-components-library": "static-1.14098",
  "ui-addon-teams": "static-1.21902",
  "upgrade-components-lib": "static-1.511",
  "navigation-components": "static-1.18816",
  "breeze-engine-lib": "static-1.1717",
  "simple-logging-lib": "static-1.3346",
  "fail-safe": "static-1.248",
  "app-governance-lib": "static-1.2376",
  "developer-experience-shared-components": "static-1.10814",
  "purchase-motions-components": "static-1.6357",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10232",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3995",
  "reference-resolvers": "static-1.8476",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4213",
  "hubspot-apollo-cache": "static-1.631",
  "universal-page-editor-lib": "static-1.3303",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3520",
  "atom": "static-1.5381",
  "merchandise-lib": "static-1.277",
  "salesImages": "static-1.557",
  "ui-addon-draggable": "static-3.5054",
  "content-assistance-lib": "static-1.8191",
  "content-media-capture": "static-1.5423",
  "customer-data-ui-utilities": "static-1.10124",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24477",
  "growth-payments-core": "static-1.26166",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3189",
  "payment-link-components": "static-1.24157",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20296",
  "ui-addon-emoji-picker": "static-1.10181",
  "ui-business-units-lib": "static-1.9383",
  "video-components-external": "static-1.12135",
  "video-data-lib": "static-1.35793",
  "navigation-messaging": "static-1.8143",
  "collaboration-sidebar": "static-1.58705",
  "crm-component-utils": "static-1.39822",
  "crm-properties-common-lib": "static-1.6184",
  "customer-data-properties": "static-1.52574",
  "external-options-client-types": "static-1.4336",
  "framework-data-schema-resolvers": "static-1.7189",
  "property-value-citations": "static-1.3188",
  "reference-resolvers-lite": "static-1.8398",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10606",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5109",
  "content-icons-ui": "static-1.2358",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1013",
  "breeze-artifacts-sdk": "static-1.311",
  "onboarding-journeys-lib": "static-1.907",
  "onboarding-scopes": "static-1.6749",
  "conversations-skeleton-state": "static-1.7540",
  "crm-message-bus": "static-1.43743",
  "customer-data-filters-ui-msw-helpers": "static-1.23337",
  "events-data-lib": "static-1.539",
  "FormUrlGenerator": "static-2.5022",
  "framework-builder-read-service-client": "static-1.4217",
  "hs-resources": "static-1.488",
  "multi-account-reference-resolvers": "static-1.1299",
  "onboarding-tours": "static-1.17110",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14450",
  "academy-common-lib": "static-1.14954",
  "dashboard-lib": "static-1.82794",
  "getting-started-shared-tasks": "static-1.19225",
  "hubspot-prosemirror-plugins": "static-1.18947",
  "share-with-third-party-component-lib": "static-1.9002",
  "ui-asset-management-lib": "static-1.11393",
  "user-context": "static-1.5415",
  "reporting-plugins": "static-1.10743",
  "reporting-reports": "static-1.68474",
  "hubs-service-types": "static-1.1554",
  "purchase-motions-api": "static-1.6360",
  "signup-constants": "static-1.19616",
  "nest": "static-1.532",
  "breeze-engine-chat-components": "static-1.695",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.199",
  "framework-listing-lib": "static-2.29479",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31416",
  "apps-service-types": "static-1.4034",
  "oauth-service-types": "static-1.4533",
  "signup-ui-url-generator": "static-2.8356",
  "onboarding-tours-client": "static-1.5325",
  "one-click-checkout": "static-1.391",
  "platform-infra-nav-components": "static-1.7888",
  "subscription-experience-data-types": "static-1.15246",
  "crm-record-cards-service-types": "static-1.3782",
  "location-customization-utils-lib": "static-1.10081",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29291",
  "content-media-composition-data-lib": "static-1.13227",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4721",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.710",
  "ui-addon-opt": "static-4.8658",
  "commerce-tours-lib": "static-1.6607",
  "growth-onboarding-reliability": "static-1.5376",
  "sales-checkout-service-client": "static-1.3824",
  "data-token-picker": "static-1.16879",
  "FileManagerLib": "static-1.40117",
  "content-media-compositions": "static-2.17234",
  "media-bridge-lib": "static-1.19397",
  "chatspot-widget-iframe": "static-1.22988",
  "collaboration-sidebar-common": "static-1.3502",
  "marketing-platform-lib": "static-1.7165",
  "card-properties-lib": "static-1.44994",
  "commerce-subscription-lib": "static-1.37763",
  "crm-actions": "static-1.6648",
  "crm-cards-sdk": "static-1.44552",
  "customer-data-properties-shared-msw-handlers": "static-1.9935",
  "customer-data-tracking": "static-1.7177",
  "calling-global-api": "static-1.65592",
  "calling-internal-common": "static-1.31615",
  "calling-lifecycle-internal": "static-1.66974",
  "calling-lifecycle-messages": "static-1.59268",
  "commerce-products-lib": "static-1.10517",
  "conditional-properties-service-client": "static-1.4010",
  "crm-index-visualization-core": "static-1.4534",
  "crm-links": "static-1.6624",
  "crm-pipelines-api-client-types": "static-1.4345",
  "formula-editor": "static-1.14757",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4422",
  "meetings-icalendar-utils-lib": "static-1.931",
  "multi-currency-client-types": "static-1.3905",
  "object-builder-ui-client": "static-1.49659",
  "pipeline-validation-client-types": "static-1.4179",
  "smart-data-capture-core": "static-1.129",
  "smart-property-lib": "static-1.8281",
  "tiered-pricing": "static-1.1943",
  "topics-actions-lib": "static-1.460",
  "ui-addon-form-validation": "static-1.11277",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.308",
  "framework-data-schema-quick-fetch": "static-1.7094",
  "restore-request-side-panel-lib": "static-1.1661",
  "growth-data-modal": "static-1.5888",
  "growth-onboarding-confetti": "static-1.3356",
  "growth-onboarding-next-action-utils": "static-1.2673",
  "onboarding-tours-utils": "static-1.1177",
  "ui-shepherd-tracker": "static-1.7946",
  "academy-service-client": "static-1.3982",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39976",
  "SafeStorage": "static-1.4698",
  "video-embed": "static-1.36627",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.24991",
  "viral-links-lib": "static-1.7371",
  "nested-table": "static-1.529",
  "timezone-utils": "static-2.5539",
  "getting-started-shared-tasks-store": "static-1.18343",
  "campaign-roi-lib": "static-1.10215",
  "campaigns-utils-lib": "static-1.3506",
  "ui-addon-calendars": "static-2.5627",
  "customer-data-views-management": "static-1.26009",
  "framework-data-table": "static-2.12539",
  "nudge-client-utils": "static-1.3146",
  "nudge-custom-ui-functions": "static-1.1482",
  "switchboard-lib": "static-1.511",
  "access-check-ui-lib": "static-1.1568",
  "app-users-service-client": "static-1.5913",
  "app-users-service-types": "static-1.5321",
  "mini-checkout-client": "static-1.27486",
  "onboarding-utils": "static-1.5663",
  "permissions-shared-i18n-strings-fe": "static-1.2120",
  "ui-coaching-tips-shared-config": "static-1.29276",
  "checkout-sdk": "static-3.24329",
  "payment-method-components": "static-1.7145",
  "touchless-buying-components": "static-1.6197",
  "upgrade-catalog-service-types": "static-1.3766",
  "edison-service-client-types": "static-1.688",
  "growth-onboarding-feedback-components": "static-1.6879",
  "audio-components": "static-1.6335",
  "FileManagerImages": "static-1.37628",
  "video-components": "static-1.14137",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92810",
  "customer-data-sidebar": "static-2.46723",
  "enrichment-lib": "static-1.342",
  "ui-addon-draggable-compat": "static-2.4559",
  "universal-record-utils-lib": "static-1.1902",
  "commerce-billing-lib": "static-1.20169",
  "commerce-shared-components-lib": "static-1.19210",
  "commerce-tools-ui-lib": "static-1.11032",
  "crm-fe-perf": "static-1.23198",
  "calling-error-reporting": "static-1.31622",
  "shared-worker-versioning": "static-1.11336",
  "calling-usage-tracker": "static-1.6831",
  "voice-sms-access-library": "static-1.2034",
  "commerce-permissions": "static-1.1072",
  "products-iframe-lib": "static-1.8579",
  "products-ui-components-shared-msw-handlers": "static-1.10990",
  "crm-index-associations-lib": "static-1.6736",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10691",
  "sales-views-client-types": "static-1.4552",
  "bark-lib": "static-1.16808",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.640",
  "policy-lib": "static-1.7096",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10754",
  "onboarding-data-sync-lib": "static-1.2501",
  "growth-onboarding-next-action-components": "static-1.2701",
  "user-context-client": "static-1.4802",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4827",
  "outpost": "static-1.4450",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22148",
  "sales-email-signature-service-client": "static-1.4139",
  "ts-utils-lib": "static-1.444",
  "crm-export-dialog": "static-1.6578",
  "crm-view-components": "static-1.1124",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7622",
  "tasks-actions-lib": "static-1.113",
  "nudge-custom-function-registry": "static-1.2903",
  "nudge-renderer-utils": "static-1.3222",
  "whisper-core-api": "static-1.7309",
  "InboxConnectUtils": "static-4.15545",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46828",
  "hub-http-rxjs": "static-1.842",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4285",
  "company-details-components": "static-1.6497",
  "react-performance-metrics-lib": "static-1.850",
  "pricing-pages-ui-components": "static-1.15784",
  "quote-checkout-service-types": "static-1.3749",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22488",
  "customer-data-email": "static-1.18516",
  "card-payment-highlight-lib": "static-1.37961",
  "commerce-contract-lib": "static-1.13303",
  "invoices-highlight-card-lib": "static-1.55718",
  "orders-highlight-card-lib": "static-1.22180",
  "products-highlight-card-lib": "static-1.18800",
  "quotes-highlight-card-lib": "static-1.72817",
  "crm-source-interpretation-lib": "static-1.5625",
  "data-agent-utils": "static-1.404",
  "crm-object-search-query-utilities": "static-1.10181",
  "utility-belt": "static-1.2827",
  "payments-enrollment-embed-lib": "static-1.23793",
  "stripe-embedded-components": "static-1.7987",
  "customer-data-rte": "static-1.33635",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6265",
  "payments-post-enroll-local-storage-lib": "static-1.5401",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38907",
  "calling-orchestration-schema": "static-1.36811",
  "react-reducer-toolkit": "static-1.16349",
  "meetings-connect-utils-lib": "static-1.7904",
  "hub-http-contrib": "static-1.3333",
  "ui-addon-sales-email": "static-1.5506",
  "access-control-lib": "static-1.10731",
  "EmailComponents": "static-1.55533",
  "EmailData": "static-1.54211",
  "redux-less": "static-2.9773",
  "company-details-service-types": "static-1.4234",
  "segments-query-core": "static-1.1718",
  "pricing-pages-api": "static-1.15649",
  "sequences-lib": "static-1.8522",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41035",
  "accounting-integrations-ui-components": "static-1.7527",
  "invoices-ui-lib": "static-1.55734",
  "commerce-products-api": "static-1.2683",
  "invoices-iframe-lib": "static-1.57792",
  "quotes-modal-lib": "static-1.103495",
  "quotes-ui-lib": "static-1.81538",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28894",
  "ContentComponents": "static-2.72069",
  "ContentData": "static-1.69188",
  "marketing-contacts-lib": "static-1.11006",
  "marketing-email-service-types": "static-1.2087",
  "messaging-editing-lib": "static-1.47124",
  "messaging-usage-based-billing-components-lib": "static-1.1986",
  "automation-ui-source-apps": "static-1.19673",
  "automation-ui-types": "static-1.20591",
  "messaging-types-lib": "static-1.46861",
  "onboarding-settings-client": "static-1.4803",
  "sequences-client-types-lib": "static-1.8379",
  "commerce-tax-lib": "static-1.833",
  "price-books-api": "static-1.1719",
  "price-books-components": "static-1.1777",
  "property-description-translator": "static-1.4134",
  "ramp-editor": "static-1.877",
  "commerce-analytics-service-client": "static-1.3812",
  "totals-ui-components": "static-1.24280",
  "SalesContentIndexUI": "static-3.9617",
  "advanced-menus-core": "static-1.15567",
  "advanced-menus-lib": "static-1.12442",
  "automation-ui-ubb": "static-1.6507",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7631",
  "data-token-views": "static-1.16860",
  "forms-utils-lib": "static-1.13084",
  "payments-embed-points-lib": "static-1.13579",
  "react-tinymce": "static-1.55966",
  "simple-menus-core": "static-1.15566",
  "simple-menus-lib": "static-1.17083",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55092",
  "tinymce-data": "static-1.41177",
  "tinymce-plugins": "static-1.58206",
  "tinymce-themes": "static-1.57062",
  "ui-brand-identity-lib": "static-1.16458",
  "ui-memberships-settings-lib": "static-1.34828",
  "videoconference-integration-components": "static-1.7264",
  "marketing-contacts-client": "static-1.7806",
  "mc-hard-limits-client-types": "static-1.201",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77893",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4210",
  "web-interactives-components": "static-1.14238",
  "web-interactives-data": "static-1.14239",
  "messaging-shared-utils-lib": "static-1.1435",
  "messaging-user-info-utils-lib": "static-1.1605",
  "email-portal-health-service-types": "static-1.1274",
  "line-items-api": "static-1.1086",
  "commerce-totals-service-types": "static-1.4028",
  "FireAlarmUi": "static-1.4717",
  "sales-templates-service-types-lib": "static-1.4381",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22527",
  "automation-ui-usage-tracking": "static-1.21990",
  "data-studio-ubb": "static-1.3494",
  "interframe": "static-3.5050",
  "layout-dnd-components": "static-1.12957",
  "layout-dnd-utils": "static-1.11932",
  "NamespacedHubStyle": "static-2.9260",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27643",
  "content-management-data-lib": "static-1.5946",
  "copilot-plugins": "static-1.11813",
  "cta-picker": "static-1.37071",
  "customer-agent-discovery-components-lib": "static-1.3936",
  "editor-components": "static-1.13640",
  "editor-iframe-lib": "static-1.8789",
  "error-messaging-js": "static-1.5491",
  "FormsCommonComponents": "static-1.86544",
  "layout-data-lib": "static-1.10257",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10945",
  "SharedLegalStrings": "static-1.2042",
  "smart-content-core": "static-1.43160",
  "smart-content-lib": "static-1.43813",
  "social-composer-lib": "static-1.60283",
  "structured-content-lib": "static-1.25903",
  "theme-previewer-lib": "static-1.53933",
  "tinymce-copilot": "static-1.17160",
  "xray-recommendation-lib": "static-1.8254",
  "automation-ui-routing": "static-1.21948",
  "sql-reporting-client-types": "static-1.5894",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42780",
  "reporting-enablement": "static-1.23818",
  "forms-ai-lib": "static-1.4754",
  "codemirror-dlb": "static-1.59452",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6733",
  "report-customization-components": "static-1.13900",
  "data-quality-ui-library": "static-1.13788",
  "reporting-filters": "static-1.993",
  "reporting-insights-lib": "static-1.2554",
  "merge-modal-lib": "static-1.12544",
  "segments-client-types": "static-1.11513"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13222",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.771",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9951",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.34",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.34",
  "foundations-theming": "/foundations-theming/static-1.4771",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8326",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10608",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11785",
  "I18n": "/I18n/static-7.1672",
  "jasmine-runner": "/jasmine-runner/static-1.6747",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.624",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13285",
  "quartz": "/quartz/static-1.7450",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17014",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3150",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10730",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12820",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7619",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11442",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9831",
  "unified-auth": "/unified-auth/static-1.912",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1194",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8396",
  "hub-http": "/hub-http/static-1.6507",
  "integrations-lib": "/integrations-lib/static-1.17016",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20716",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.702",
  "property-management-iframe": "/property-management-iframe/static-1.14123",
  "quartz-config": "/quartz-config/static-1.1228",
  "quartz-core": "/quartz-core/static-1.6669",
  "quartz-routing": "/quartz-routing/static-1.880",
  "quick-fetch": "/quick-fetch/static-1.4127",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4962",
  "ts-schema": "/ts-schema/static-1.4289",
  "ui-universal-auth": "/ui-universal-auth/static-1.9398",
  "UIComponents": "/UIComponents/static-3.8731",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3615",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3727",
  "quartz-webpack": "/quartz-webpack/static-1.3674",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.528",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9702",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5180",
  "pulse": "/pulse/static-1.924",
  "react-codemirror": "/react-codemirror/static-1.10936",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.596",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.34",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2487",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9719",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.69",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5553",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2624",
  "ui-fonts": "/ui-fonts/static-1.1047",
  "ui-images": "/ui-images/static-2.1246",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3254",
  "foundations-theming-base": "/foundations-theming-base/static-1.3756",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.796",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3437",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4608",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8998",
  "ai-rendering-library": "/ai-rendering-library/static-1.11092",
  "chirp-fetch": "/chirp-fetch/static-1.2189",
  "connections-embed-lib": "/connections-embed-lib/static-1.1503",
  "copilot-toolkit": "/copilot-toolkit/static-1.11841",
  "feedback-loader": "/feedback-loader/static-1.29802",
  "laboratory-lib": "/laboratory-lib/static-3.7447",
  "marketplace-embed": "/marketplace-embed/static-1.22897",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10611",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20671",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14886",
  "sanitize-text": "/sanitize-text/static-1.8449",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7197",
  "quartz-head": "/quartz-head/static-1.1115",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4950",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4443",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2685",
  "reporting-data": "/reporting-data/static-1.68797",
  "cssUtils": "/cssUtils/static-1.915",
  "flux-actions": "/flux-actions/static-1.367",
  "react-colorpicker": "/react-colorpicker/static-2.10513",
  "react-dnd-compat": "/react-dnd-compat/static-1.4912",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10665",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.682",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19248",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4803",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.34",
  "quartz-i18n": "/quartz-i18n/static-1.1125",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.445",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1339",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.40",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1015",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.129",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.471",
  "slack-ui-library": "/slack-ui-library/static-1.10694",
  "fsm": "/fsm/static-1.4044",
  "customer-data-objects": "/customer-data-objects/static-1.7986",
  "property-translator": "/property-translator/static-1.5691",
  "hs-locale-management": "/hs-locale-management/static-1.290",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8218",
  "hs-promise-utils": "/hs-promise-utils/static-1.5890",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5172",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14431",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5902",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8072",
  "sanitize": "/sanitize/static-1.4767",
  "superstore": "/superstore/static-1.5052",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10565",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8343",
  "hub-http-janus": "/hub-http-janus/static-1.878",
  "hubspotter-http": "/hubspotter-http/static-1.4861",
  "immutable-less": "/immutable-less/static-1.4945",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18123",
  "nav-meta": "/nav-meta/static-1.30453",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18377",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1032",
  "ai-studio-lib": "/ai-studio-lib/static-1.12440",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18955",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.476",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9371",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8321",
  "ui-product-approvals": "/ui-product-approvals/static-1.29137",
  "ui-tool-access": "/ui-tool-access/static-1.10450",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4052",
  "property-management-common": "/property-management-common/static-1.6411",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.65",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.440",
  "quartz-auth": "/quartz-auth/static-1.1125",
  "quartz-test": "/quartz-test/static-1.1125",
  "quartz-tracking": "/quartz-tracking/static-1.829",
  "trellis-components": "/trellis-components/static-1.2643",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.372",
  "HubStyle": "/HubStyle/static-2.12092",
  "bender-build-tools": "/bender-build-tools/static-1.3441",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22997",
  "ContentUtils": "/ContentUtils/static-1.69113",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13326",
  "sassPrefix": "/sassPrefix/static-1.187",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.427",
  "batch-promise": "/batch-promise/static-1.1838",
  "event-emitter": "/event-emitter/static-1.1248",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5749",
  "magpie-types": "/magpie-types/static-1.5209",
  "stylex-utils": "/stylex-utils/static-1.139",
  "trellis-theming": "/trellis-theming/static-1.1269",
  "avatar-components": "/avatar-components/static-1.2775",
  "breeze-engine-core": "/breeze-engine-core/static-1.995",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.717",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40902",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13472",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15494",
  "ExportDialog": "/ExportDialog/static-6.10673",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.107",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.600",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42032",
  "reporting-snowflake": "/reporting-snowflake/static-1.57414",
  "reporting-ui-components": "/reporting-ui-components/static-2.66067",
  "reporting-visualizations": "/reporting-visualizations/static-1.60872",
  "trial-components-library": "/trial-components-library/static-1.14098",
  "ui-addon-teams": "/ui-addon-teams/static-1.21902",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.511",
  "navigation-components": "/navigation-components/static-1.18816",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1717",
  "simple-logging-lib": "/simple-logging-lib/static-1.3346",
  "fail-safe": "/fail-safe/static-1.248",
  "app-governance-lib": "/app-governance-lib/static-1.2376",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10814",
  "purchase-motions-components": "/purchase-motions-components/static-1.6357",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10232",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3995",
  "reference-resolvers": "/reference-resolvers/static-1.8476",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4213",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.631",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3303",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3520",
  "atom": "/atom/static-1.5381",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "salesImages": "/salesImages/static-1.557",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5054",
  "content-assistance-lib": "/content-assistance-lib/static-1.8191",
  "content-media-capture": "/content-media-capture/static-1.5423",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10124",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24477",
  "growth-payments-core": "/growth-payments-core/static-1.26166",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3189",
  "payment-link-components": "/payment-link-components/static-1.24157",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20296",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10181",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9383",
  "video-components-external": "/video-components-external/static-1.12135",
  "video-data-lib": "/video-data-lib/static-1.35793",
  "navigation-messaging": "/navigation-messaging/static-1.8143",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58705",
  "crm-component-utils": "/crm-component-utils/static-1.39822",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6184",
  "customer-data-properties": "/customer-data-properties/static-1.52574",
  "external-options-client-types": "/external-options-client-types/static-1.4336",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7189",
  "property-value-citations": "/property-value-citations/static-1.3188",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8398",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10606",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5109",
  "content-icons-ui": "/content-icons-ui/static-1.2358",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1013",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.311",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.907",
  "onboarding-scopes": "/onboarding-scopes/static-1.6749",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7540",
  "crm-message-bus": "/crm-message-bus/static-1.43743",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23337",
  "events-data-lib": "/events-data-lib/static-1.539",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5022",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4217",
  "hs-resources": "/hs-resources/static-1.488",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1299",
  "onboarding-tours": "/onboarding-tours/static-1.17110",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14450",
  "academy-common-lib": "/academy-common-lib/static-1.14954",
  "dashboard-lib": "/dashboard-lib/static-1.82794",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19225",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18947",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9002",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11393",
  "user-context": "/user-context/static-1.5415",
  "reporting-plugins": "/reporting-plugins/static-1.10743",
  "reporting-reports": "/reporting-reports/static-1.68474",
  "hubs-service-types": "/hubs-service-types/static-1.1554",
  "purchase-motions-api": "/purchase-motions-api/static-1.6360",
  "signup-constants": "/signup-constants/static-1.19616",
  "nest": "/nest/static-1.532",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.695",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.199",
  "framework-listing-lib": "/framework-listing-lib/static-2.29479",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31416",
  "apps-service-types": "/apps-service-types/static-1.4034",
  "oauth-service-types": "/oauth-service-types/static-1.4533",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8356",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5325",
  "one-click-checkout": "/one-click-checkout/static-1.391",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7888",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3782",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10081",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29291",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13227",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4721",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.710",
  "ui-addon-opt": "/ui-addon-opt/static-4.8658",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6607",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5376",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3824",
  "data-token-picker": "/data-token-picker/static-1.16879",
  "FileManagerLib": "/FileManagerLib/static-1.40117",
  "content-media-compositions": "/content-media-compositions/static-2.17234",
  "media-bridge-lib": "/media-bridge-lib/static-1.19397",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22988",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3502",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7165",
  "card-properties-lib": "/card-properties-lib/static-1.44994",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37763",
  "crm-actions": "/crm-actions/static-1.6648",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44552",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9935",
  "customer-data-tracking": "/customer-data-tracking/static-1.7177",
  "calling-global-api": "/calling-global-api/static-1.65592",
  "calling-internal-common": "/calling-internal-common/static-1.31615",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66974",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59268",
  "commerce-products-lib": "/commerce-products-lib/static-1.10517",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4010",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4534",
  "crm-links": "/crm-links/static-1.6624",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4345",
  "formula-editor": "/formula-editor/static-1.14757",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4422",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.931",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3905",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49659",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4179",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.129",
  "smart-property-lib": "/smart-property-lib/static-1.8281",
  "tiered-pricing": "/tiered-pricing/static-1.1943",
  "topics-actions-lib": "/topics-actions-lib/static-1.460",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11277",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.308",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7094",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1661",
  "growth-data-modal": "/growth-data-modal/static-1.5888",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3356",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2673",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1177",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7946",
  "academy-service-client": "/academy-service-client/static-1.3982",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39976",
  "SafeStorage": "/SafeStorage/static-1.4698",
  "video-embed": "/video-embed/static-1.36627",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24991",
  "viral-links-lib": "/viral-links-lib/static-1.7371",
  "nested-table": "/nested-table/static-1.529",
  "timezone-utils": "/timezone-utils/static-2.5539",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18343",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10215",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3506",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5627",
  "customer-data-views-management": "/customer-data-views-management/static-1.26009",
  "framework-data-table": "/framework-data-table/static-2.12539",
  "nudge-client-utils": "/nudge-client-utils/static-1.3146",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1482",
  "switchboard-lib": "/switchboard-lib/static-1.511",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1568",
  "app-users-service-client": "/app-users-service-client/static-1.5913",
  "app-users-service-types": "/app-users-service-types/static-1.5321",
  "mini-checkout-client": "/mini-checkout-client/static-1.27486",
  "onboarding-utils": "/onboarding-utils/static-1.5663",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2120",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29276",
  "checkout-sdk": "/checkout-sdk/static-3.24329",
  "payment-method-components": "/payment-method-components/static-1.7145",
  "touchless-buying-components": "/touchless-buying-components/static-1.6197",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3766",
  "edison-service-client-types": "/edison-service-client-types/static-1.688",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6879",
  "audio-components": "/audio-components/static-1.6335",
  "FileManagerImages": "/FileManagerImages/static-1.37628",
  "video-components": "/video-components/static-1.14137",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92810",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46723",
  "enrichment-lib": "/enrichment-lib/static-1.342",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4559",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1902",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20169",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19210",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11032",
  "crm-fe-perf": "/crm-fe-perf/static-1.23198",
  "calling-error-reporting": "/calling-error-reporting/static-1.31622",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11336",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6831",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2034",
  "commerce-permissions": "/commerce-permissions/static-1.1072",
  "products-iframe-lib": "/products-iframe-lib/static-1.8579",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10990",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6736",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10691",
  "sales-views-client-types": "/sales-views-client-types/static-1.4552",
  "bark-lib": "/bark-lib/static-1.16808",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.640",
  "policy-lib": "/policy-lib/static-1.7096",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10754",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2501",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2701",
  "user-context-client": "/user-context-client/static-1.4802",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4827",
  "outpost": "/outpost/static-1.4450",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22148",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4139",
  "ts-utils-lib": "/ts-utils-lib/static-1.444",
  "crm-export-dialog": "/crm-export-dialog/static-1.6578",
  "crm-view-components": "/crm-view-components/static-1.1124",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7622",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.113",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2903",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3222",
  "whisper-core-api": "/whisper-core-api/static-1.7309",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15545",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46828",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.842",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4285",
  "company-details-components": "/company-details-components/static-1.6497",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.850",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15784",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3749",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22488",
  "customer-data-email": "/customer-data-email/static-1.18516",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37961",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13303",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55718",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22180",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18800",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72817",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5625",
  "data-agent-utils": "/data-agent-utils/static-1.404",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10181",
  "utility-belt": "/utility-belt/static-1.2827",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23793",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7987",
  "customer-data-rte": "/customer-data-rte/static-1.33635",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6265",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5401",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38907",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36811",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16349",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7904",
  "hub-http-contrib": "/hub-http-contrib/static-1.3333",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5506",
  "access-control-lib": "/access-control-lib/static-1.10731",
  "EmailComponents": "/EmailComponents/static-1.55533",
  "EmailData": "/EmailData/static-1.54211",
  "redux-less": "/redux-less/static-2.9773",
  "company-details-service-types": "/company-details-service-types/static-1.4234",
  "segments-query-core": "/segments-query-core/static-1.1718",
  "pricing-pages-api": "/pricing-pages-api/static-1.15649",
  "sequences-lib": "/sequences-lib/static-1.8522",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41035",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7527",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55734",
  "commerce-products-api": "/commerce-products-api/static-1.2683",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57792",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103495",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81538",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28894",
  "ContentComponents": "/ContentComponents/static-2.72069",
  "ContentData": "/ContentData/static-1.69188",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.11006",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2087",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47124",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1986",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19673",
  "automation-ui-types": "/automation-ui-types/static-1.20591",
  "messaging-types-lib": "/messaging-types-lib/static-1.46861",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4803",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8379",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.833",
  "price-books-api": "/price-books-api/static-1.1719",
  "price-books-components": "/price-books-components/static-1.1777",
  "property-description-translator": "/property-description-translator/static-1.4134",
  "ramp-editor": "/ramp-editor/static-1.877",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3812",
  "totals-ui-components": "/totals-ui-components/static-1.24280",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9617",
  "advanced-menus-core": "/advanced-menus-core/static-1.15567",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12442",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6507",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7631",
  "data-token-views": "/data-token-views/static-1.16860",
  "forms-utils-lib": "/forms-utils-lib/static-1.13084",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13579",
  "react-tinymce": "/react-tinymce/static-1.55966",
  "simple-menus-core": "/simple-menus-core/static-1.15566",
  "simple-menus-lib": "/simple-menus-lib/static-1.17083",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55092",
  "tinymce-data": "/tinymce-data/static-1.41177",
  "tinymce-plugins": "/tinymce-plugins/static-1.58206",
  "tinymce-themes": "/tinymce-themes/static-1.57062",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16458",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34828",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7264",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7806",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.201",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77893",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4210",
  "web-interactives-components": "/web-interactives-components/static-1.14238",
  "web-interactives-data": "/web-interactives-data/static-1.14239",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1435",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1605",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1274",
  "line-items-api": "/line-items-api/static-1.1086",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4028",
  "FireAlarmUi": "/FireAlarmUi/static-1.4717",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4381",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22527",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21990",
  "data-studio-ubb": "/data-studio-ubb/static-1.3494",
  "interframe": "/interframe/static-3.5050",
  "layout-dnd-components": "/layout-dnd-components/static-1.12957",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11932",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9260",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27643",
  "content-management-data-lib": "/content-management-data-lib/static-1.5946",
  "copilot-plugins": "/copilot-plugins/static-1.11813",
  "cta-picker": "/cta-picker/static-1.37071",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3936",
  "editor-components": "/editor-components/static-1.13640",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8789",
  "error-messaging-js": "/error-messaging-js/static-1.5491",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86544",
  "layout-data-lib": "/layout-data-lib/static-1.10257",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10945",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2042",
  "smart-content-core": "/smart-content-core/static-1.43160",
  "smart-content-lib": "/smart-content-lib/static-1.43813",
  "social-composer-lib": "/social-composer-lib/static-1.60283",
  "structured-content-lib": "/structured-content-lib/static-1.25903",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53933",
  "tinymce-copilot": "/tinymce-copilot/static-1.17160",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8254",
  "automation-ui-routing": "/automation-ui-routing/static-1.21948",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5894",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42780",
  "reporting-enablement": "/reporting-enablement/static-1.23818",
  "forms-ai-lib": "/forms-ai-lib/static-1.4754",
  "codemirror-dlb": "/codemirror-dlb/static-1.59452",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6733",
  "report-customization-components": "/report-customization-components/static-1.13900",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13788",
  "reporting-filters": "/reporting-filters/static-1.993",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2554",
  "merge-modal-lib": "/merge-modal-lib/static-1.12544",
  "segments-client-types": "/segments-client-types/static-1.11513"
}
};
